export const painPoints = [
  {
    emoji: '🧭',
    title: "You don't know where to start",
    desc: 'The consultation process looks overwhelming and you are buried in paperwork. This method organizes everything: first the clinical foundation, then the assessment, then the modular meal plan, then the behavior change.',
  },
  {
    emoji: '🔤',
    title: 'You get stuck with meal planning (and it takes hours)',
    desc: 'You learn it here the guided way, so you recognize nutrient patterns and prescribe with intention. No more confusion between calories, macros and food choices.',
  },
  {
    emoji: '🧩',
    title: "You know nutrition but can't build a complete practice workflow",
    desc: 'You learn the complete phase structure to build protocols that actually make sense and start patients on a real path to health from day one.',
  },
  {
    emoji: '💭',
    title: 'You prescribe but forget the follow-up criteria',
    desc: 'You get concrete assessment checkpoints and advancement guidelines so what you prescribe actually works instead of stalling in a week.',
  },
  {
    emoji: '🎯',
    title: 'You manage clients but fear clinical errors',
    desc: 'Guessing is dangerous. A clear clinical framework is what keeps your practice safe and your professional license protected.',
  },
  {
    emoji: '🔁',
    title: 'You started a course and quit after two weeks',
    desc: 'One-off lessons are not progress. A complete 6-volume system with visible milestones is what keeps you going until you manage your first complex case with confidence.',
  },
];
